// extracted by mini-css-extract-plugin
export var backToTop = "Layout-module--backToTop--e42d1";
export var backToTopIcon = "Layout-module--backToTopIcon--6385a";
export var entered = "Layout-module--entered--9ff44";
export var entering = "Layout-module--entering--9a9d9";
export var exited = "Layout-module--exited--697ea";
export var exiting = "Layout-module--exiting--59a54";
export var footer = "Layout-module--footer--41857";
export var layout = "Layout-module--layout--3dfe5";
export var page = "Layout-module--page--9906f";
export var wrap = "Layout-module--wrap--6ce46";